$(document).ready(function () {
  function checkProtectCart() {
    setTimeout(function () {
      var is_protect_product = false;
      jQuery.getJSON(window.Shopify.routes.root + 'cart.js', function (cart) {
        for (r = 0; r < cart.items.length; r++) {
          if (cart.items[r].url.indexOf('/products/routeins') >= 0) {
            is_protect_product = true;
          }
        }
      });
      if ($('.rw-checkbox-span.rw-checked').length > 0 && !is_protect_product) {
        $('.rw-checkbox-span').click();
      }
    }, 1000);
  }
  $('.product-form__atc button').on('click', function () {
    /*checkProtectCart();*/
  });

  $('.site-header__cart').on('click', function () {
    setTimeout(function () {
      $('#ajax-drawer .item-content-container .item-content-right').each(function (index) {
        if ($(this).find('input.item-quantity').length <= 0) {
          $(this).addClass('free-item');
        }
      });
    }, 4000);
  });

  $(document).ajaxComplete(function (event, request, settings) {
    $('#ajax-drawer .item-content-container .item-content-right').each(function (index) {
      if ($(this).find('input.item-quantity').length <= 0) {
        $(this).addClass('free-item');
      }
    });
  });

  $(document).on('click', '.rw-on-text', function () {
    console.log('protection off');

    var old_item_count = $('#ajax-drawer .item-content-container .ajax-remove').length;
    function rw_update() {
      jQuery.getJSON(window.Shopify.routes.root + 'cart.js', function (cart) {
        var new_item_count = cart.items.length;
        if (old_item_count != new_item_count) {
          ajaxCartLoad();
          clearInterval(rw_timer);
        }
      });
    }
    const rw_timer = setInterval(rw_update, 2000);
  });
  $(document).on('click', '.rw-off-text', function () {
    console.log('protection on');

    var old_item_count = $('#ajax-drawer .item-content-container .ajax-remove').length;
    function rw_update() {
      jQuery.getJSON(window.Shopify.routes.root + 'cart.js', function (cart) {
        var new_item_count = cart.items.length;
        if (old_item_count != new_item_count) {
          ajaxCartLoad();
          clearInterval(rw_timer);
        }
      });
    }
    const rw_timer = setInterval(rw_update, 2000);
  });
});

// RESERVE MODAL
$(document).ready(function () {
  $('.product-card__badge.reserve').click(function () {
    $('.reserve-modal').addClass('show');
    $('body').addClass('noscroll');
  });

  $('.reserve-modal--box__close').click(function(){
    $('.reserve-modal').removeClass('show');
    $('body').removeClass('noscroll');
  });
});